import { render, staticRenderFns } from "./ShopAll.vue?vue&type=template&id=0688ea82&scoped=true&"
import script from "./ShopAll.vue?vue&type=script&lang=js&"
export * from "./ShopAll.vue?vue&type=script&lang=js&"
import style0 from "./ShopAll.vue?vue&type=style&index=0&id=0688ea82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0688ea82",
  null
  
)

export default component.exports